module.exports = __webpack_public_path__ + "RohitLalwani-bfa37d7f.webp";